import React from 'react';

import { A } from './a';

export function JiraLink({ ticket }: { ticket: string | undefined }) {
  if (!ticket) return '-';

  return (
    <A
      href={`https://haydenai.atlassian.net/browse/${encodeURIComponent(ticket)}`}
      target="_blank"
      rel="noopener noreferrer"
      title={`Open ${ticket} in Jira (opens in new tab)`}>
      {ticket} ↗
    </A>
  );
}
